import { OktaAuth } from '@okta/okta-auth-js';

const REDIRECT_URI = window.location.origin + '/callback';

export const OKTA_CONFIG = {
  issuer: 'https://8x8.okta.com',
  clientId: '0oa12d6jfuwex8LXQ298',
  redirectUri: REDIRECT_URI,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
};

// Demo mode: when clientId is left as the placeholder, oktaAuth is null
// and useAuth falls back to a synthetic admin user. Useful for local dev
// before the Okta app is registered. Production must have a real clientId.
export const oktaAuth =
  OKTA_CONFIG.clientId !== '<OKTA_CLIENT_ID>' ? new OktaAuth(OKTA_CONFIG) : null;

export const isDemoMode = !oktaAuth;
